import { render, staticRenderFns } from "./PxCriterioCentroCusto.vue?vue&type=template&id=36b6e333&"
import script from "./PxCriterioCentroCusto.vue?vue&type=script&lang=js&"
export * from "./PxCriterioCentroCusto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports